import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Transaction = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { transactions } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "amount",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Amount',
        },
        {
          name: "date",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Date'
        },
          {
            name: "status",
            icon: 'fa-solid fa-user',
            type: 'select',
            vals: [
              {name: 'Pending', option:'Pending'},
              {name: 'Completed', option:'Completed'},
            ],
          }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['TraID', 'UserID', 'Amount', 'Date', 'Status', 'Type', 'Account', 'TrackingID']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/transactions.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={false} value='Add New Transactions' name='Transactions'/>
        <div className="w3-container">
        <Table tableName='transactions' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Transactions' columns={userColumns} data={transactions ? transactions : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Transaction